import React from 'react'
import Modal from '../../components/Modal'
// import SuccessIcon from '../../assets/images/unsplash.png'
import { ReactComponent as Close } from '../../assets/images/x.svg'
import styled from 'styled-components'
// import { useModalOpen, useToggleSuccessModal } from '../../state/application/hooks'
// import { ApplicationModal } from 'state/application/actions'

// const HeadlineText = styled.div`
//   font-size: 24px;
//   font-weight: 500;
//   line-height: 28.44px;
//   padding-top: 42px;
// `

// const BodyText = styled.div`
//   font-size: 14px;
//   font-weight: 400;
//   line-height: 23px;
//   padding-top: 8px;
//   text-align: center;
//   width: 225px;
// `

const Wrapper = styled.div`
  background: #222429;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
`

const CloseColor = styled(Close)`
  path {
    stroke: ${({ theme }) => theme.text4};
  }
`

const CloseIcon = styled.div`
  position: absolute;
  right: 1rem;
  top: 14px;
  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }
`

function SuccessModal({
  open,
  handleToggle,
  image,
  title,
  date,
  description,
  endDate
}: {
  open: boolean
  handleToggle: () => void
  image: string
  title: string
  date: any
  description: string
  endDate: any
}) {
  console.log({ date, endDate })

  return (
    <Modal isOpen={open} onDismiss={handleToggle} minHeight={false} maxHeight={90}>
      <Wrapper>
        <CloseIcon onClick={handleToggle}>
          <CloseColor />
        </CloseIcon>
        <img src={image} alt="gambar" style={{ maxHeight: '312px', maxWidth: '480px' }} />
        <div style={{ padding: '0 24px', paddingTop: '24px' }}>
          <div
            style={{
              fontWeight: 500,
              fontSize: '24px'
            }}
          >
            {title}
          </div>
          <div
            style={{
              color: '#D06CFF',
              fontSize: '14px',
              fontWeight: 500,
              paddingTop: '4px'
            }}
          >
            {date.formatted}
          </div>
          <div
            style={{
              paddingTop: '24px',
              fontWeight: 400,
              fontSize: '14px',
              lineHeight: '23px'
            }}
          >
            {description}
          </div>
          <a
            href={`https://www.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${date !== '' &&
              date.realDate
                .toISOString()
                .replaceAll('-', '')
                .replaceAll(':', '')
                .split('.')[0] + 'Z'}/${endDate !== '' &&
              endDate.realDate
                .toISOString()
                .replaceAll('-', '')
                .replaceAll(':', '')
                .split('.')[0] + 'Z'}&details=${description}&sf=true&output=xml`}
            target="_blank"
            rel="noreferrer"
          >
            <button
              style={{
                backgroundColor: '#522BA4',
                borderRadius: '8px',
                border: 'none',
                color: 'white',
                width: '100%',
                padding: '8px',
                marginTop: '36px',
                marginBottom: '24px',
                outline: 'none',
                cursor: 'pointer'
              }}
            >
              Add to Calendar
            </button>
          </a>
        </div>
      </Wrapper>
    </Modal>
  )
}

export default SuccessModal
